import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@shared/components/ui/input-otp";

interface AuthOtpInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SLOT_CLASS =
  "h-12 w-12 sm:h-14 sm:w-14 text-xl sm:text-2xl border-foreground/30 font-medium";

const OTP_LENGTH = 6;

/**
 * Shared 6-digit OTP input used by SignInPage and AuthLoginPage. Renders one
 * connected group (matches the format users see in the verification email).
 */
export function AuthOtpInput({ value, onChange, disabled }: AuthOtpInputProps) {
  return (
    <InputOTP
      maxLength={OTP_LENGTH}
      value={value}
      onChange={onChange}
      disabled={disabled}
      autoFocus
    >
      <InputOTPGroup>
        {Array.from({ length: OTP_LENGTH }, (_, i) => (
          <InputOTPSlot key={i} index={i} className={SLOT_CLASS} />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
}
